import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mark } from './Mark';
import { ThemeToggleButton } from './ThemeSwitcher';

const SECTIONS = [
  { hash: '#about', label: 'About' },
  { hash: '#teaching', label: 'Teaching' },
  { hash: '#performance', label: 'Performance' },
  { hash: '#listening', label: 'Listening' },
  { hash: '#lessons', label: 'Lessons' },
  { hash: '#contact', label: 'Contact' },
];

export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  // Close the sheet on resize back to desktop
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 720) setMenuOpen(false); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav className={`nav ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'nav--menu-open' : ''}`}>
        <Link to="/" className="nav__brand" onClick={closeMenu}>
          <Mark />
          <span>Berti</span>
        </Link>

        <div className="nav__links nav__links--desktop">
          {SECTIONS.map(s => (
            <Link key={s.hash} to={onHome ? s.hash : `/${s.hash}`}>{s.label}</Link>
          ))}
          <ThemeToggleButton className="theme-toggle--nav" />
        </div>

        <div className="nav__mobile-controls">
          <ThemeToggleButton />
          <button
            className={`hamburger ${menuOpen ? 'is-open' : ''}`}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(o => !o)}
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      <div
        className={`nav__sheet ${menuOpen ? 'is-open' : ''}`}
        aria-hidden={!menuOpen}
        onClick={closeMenu}
      >
        <div className="nav__sheet-inner" onClick={e => e.stopPropagation()}>
          {SECTIONS.map(s => (
            <Link
              key={s.hash}
              to={onHome ? s.hash : `/${s.hash}`}
              onClick={closeMenu}
              className="nav__sheet-link"
            >
              {s.label}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
